import type { HomeScreenTaskSuggestion } from '@frontend/react-domain';
import { TabPill, Text, XStack, YStack } from '@frontend/web-react';
import type { ClassName } from '@frontend/web-utils';
import { concatClasses } from '@frontend/web-utils';

type SuggestionCardProps = {
  containerClassName?: ClassName;
  onClick: () => void;
  onDismiss: () => void;
  onSave: () => void;
  suggestion: HomeScreenTaskSuggestion;
};

export const SuggestionCard = ({ containerClassName, onClick, onDismiss, onSave, suggestion }: SuggestionCardProps) => {
  return (
    <YStack
      className={concatClasses(
        'group relative rounded-lg border-1 border-cream-200 bg-trueWhite p-lg hover-background-effect cursor-pointer',
        containerClassName,
      )}
      onClick={onClick}
    >
      <XStack alignItems="center" justifyContent="between">
        {/* eslint-disable-next-line tailwindcss/no-arbitrary-value */}
        <Text className="font-[500] text-neutral-950" lineClamp={1} type="p-lg">
          {suggestion.shortenedLabel || suggestion.draftDescription}
        </Text>
        <XStack className="gap-xs hidden md:group-hover:flex absolute top-md right-md">
          <TabPill
            className="bg-cool-100 border-transparent"
            color="primary"
            hoverEffect="opacity"
            iconColor="primary"
            label="Dismiss"
            leftIconName="IconTrash"
            onClick={(e) => {
              e.stopPropagation();
              onDismiss();
            }}
            useCustomBackground
          />
          <TabPill
            // eslint-disable-next-line tailwindcss/no-arbitrary-value
            className="[background:linear-gradient(97.16deg,#EEFB86_-9.23%,#C7E0FF_106.01%)] border-transparent"
            color="primary"
            hoverEffect="opacity"
            iconColor="primary"
            label="Save"
            leftIconName="IconBookmark"
            onClick={(e) => {
              e.stopPropagation();
              onSave();
            }}
            useCustomBackground
          />
        </XStack>
      </XStack>
    </YStack>
  );
};
